module.exports = __webpack_public_path__ + "static/media/biteicon.55af5b75.png";